import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Header } from '@/components/elements/Header';
import { ShareDeviceHeader } from '@/components/elements/ShareDeviceHeader';
import { StaffHeader } from '@/components/elements/StaffHeader';
import { isStaffPage } from '@/utils/isStaffPage';
import { parseSubdomain } from '@/utils/subdomainParser';

interface ErrorLayoutProps {
  titleKey: string;
  messageKey: string;
  showBackButton?: boolean;
  backButtonTextKey?: string;
  onBackClick?: () => void;
}

export const ErrorLayout: React.FC<ErrorLayoutProps> = ({
  titleKey,
  messageKey,
  showBackButton = true,
  backButtonTextKey = 'errors.page.backToLogin',
  onBackClick,
}) => {
  const { t } = useTranslation();
  const location = useLocation();

  // ページタイプを判定
  const isStaffPageValue = isStaffPage(location.pathname);
  const isShareDevice = parseSubdomain(window.location.hostname) !== null;
  const isPersonalDevice = !isStaffPageValue && !isShareDevice;

  // ページタイプに応じて適切なヘッダーをレンダリング
  const renderHeader = () => {
    if (isStaffPageValue) {
      return <StaffHeader showLogout={false} />;
    } else if (isShareDevice) {
      return <ShareDeviceHeader showBackToTop={false} />;
    } else {
      return <Header showLanguageMenu={false} showNavMenu={false} />;
    }
  };

  // 個人端末の場合はRouting.tsxのHeaderを使用するため、ヘッダーを含めない
  if (isPersonalDevice) {
    return (
      <div className="error-page">
        <div className="error-page__content">
          <h1 className="error-page__title">{t(titleKey)}</h1>

          <p className="error-page__message">{t(messageKey)}</p>

          {showBackButton && (
            <div className="error-page__button-wrapper">
              <button onClick={onBackClick} className="error-page-button">
                {t(backButtonTextKey)}
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  // 共有端末とスタッフページの場合
  return (
    <div className="error-page">
      <div className="error-page__header">{renderHeader()}</div>

      <div className="error-page__main">
        <div className="error-page__content">
          <h1 className="error-page__title">{t(titleKey)}</h1>

          <p className="error-page__message">{t(messageKey)}</p>

          {showBackButton && (
            <div className="error-page__button-wrapper">
              <button onClick={onBackClick} className="error-page-button">
                {t(backButtonTextKey)}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
